var _rect, _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStopBus = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 3,
  height: 8,
  x: 14.5,
  y: 22,
  fill: "#333",
  rx: 1.5
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 13,
  r: 11
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8 7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H10a2 2 0 0 1-2-2z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M20.68 7.02c-1.6-.2-3.06-.3-4.66-.3-1.66 0-3.1.08-4.68.3-.48.06-.76.34-.76.76v9.36c0 .3.22.5.42.56l.6.1v1.26c0 .14.12.24.28.24h.96c.12 0 .24-.1.24-.24v-1.12c.78.1 1.84.14 2.9.14 1.08 0 2.18-.04 2.94-.14v1.12c0 .14.14.24.26.24h.96c.16 0 .28-.1.28-.24V17.8l.6-.1c.22-.06.42-.24.42-.56V7.78c0-.42-.28-.7-.76-.76m-.1 7.24c0 .26-.1.4-.42.44-1.14.2-2.64.4-4.1.4-1.54 0-3-.18-4.16-.44-.32-.06-.44-.18-.44-.44V8.38c0-.26.12-.44.44-.44l8.26.04c.32 0 .42.18.42.44zm-8.26 2.58c-.3-.02-.54-.26-.54-.54.02-.26.26-.5.54-.5s.52.24.52.5c0 .3-.24.54-.52.54m7.3 0a.56.56 0 0 1-.52-.54c.02-.26.26-.5.52-.5.28 0 .52.24.52.5 0 .3-.24.54-.52.54"
})));
export { SvgStopBus as ReactComponent };